import React from 'react';

export const FormHeading = ({
    formHeadingTag,
    children,
    classNames,
}: {
    formHeadingTag?: `h1` | `h2` | `h3` | `h4` | `h5`;
    children?: JSX.Element | string;
    classNames?: string[];
}): JSX.Element => {
    if (!children) return null;

    const formHeading = React.createElement(formHeadingTag, {
        className: classNames ? `${classNames?.join(` `)}` : ``,
        children,
    });

    return formHeading;
};
